<template>
  <div class="overlay">
    <form class="form" autocomplete="off" @submit.prevent="cadastrarEdicao()">
      <div class="modal-header">
        <span class="modal-label">Editar dados</span>
        <button class="btn-fechar-modal" type="button" aria-label="Fechar modal"
          @click.prevent="handleVoltar('fechar')">
          ×
        </button>
      </div>
      <div id="campos-form-container">
        <div id="campos-form">
          <div id="informacoes">
            <div class="mb-3">
              <div class="label-container">
                <label for="nome" class="form-label required">Nome*</label>
              </div>
              <input type="text" id="nome" class="form-control" v-model="dados.nome" required />
            </div>
            <section>
              <div>
                <label for="cpf" class="form-label required">CPF:</label>
                <input type="text" class="form-control" id="cpf" v-model="dados.cpf" placeholder="000.000.000-00"
                  v-maska="'###.###.###-##'" />
              </div>
              <div class="form-group">
                <label for="data-nascimento" class="form-label required">
                  Data de Nascimento:
                </label>

                <input type="date" class="form-control" id="data-nascimento" v-model="dados.dataNascimento"
                  :max="dataMaxima" />
              </div>
            </section>
            <div class="mb-3">
              <div class="label-container">
                <label for="arquivo" class="form-label" :style="houveAlteracao() && !arquivo
                  ? 'color: var(--vermelho); font-weight: bold;'
                  : ''
                  ">
                  Documento (PDF) <span v-if="houveAlteracao()">*</span>
                </label>
              </div>
              <input type="file" id="arquivo" class="form-control" accept=".pdf,application/pdf" @change="handleArquivo"
                :style="houveAlteracao() && !arquivo
                  ? 'border-color: var(--vermelho); box-shadow: 0 0 0 0.15rem rgba(239, 68, 68, 0.25);'
                  : ''
                  " />
              <span v-if="arquivo" style="
                  font-size: 13px;
                  color: var(--cinza-medio);
                  margin-top: 4px;
                  display: block;
                ">
                📄 {{ arquivo.name }}
              </span>
              <span v-else-if="houveAlteracao()" style="
                  font-size: 12px;
                  color: var(--vermelho);
                  margin-top: 4px;
                  display: block;
                  font-weight: 500;
                ">
                ⚠️ Aguardando documento PDF justificativo...
              </span>
            </div>
            <div id="regras-container">
              <div class="regras-section">
                <div class="section-label">
                  <i class="ti ti-lock"></i>
                  Regras adicionadas
                  <span class="badge-count">{{
                    regrasSelecionadas.length
                  }}</span>
                </div>
                <div class="regras-group">
                  <span v-if="regrasSelecionadas.length === 0" class="empty-hint">
                    Nenhuma regra adicionada ainda.
                  </span>
                  <div v-for="regra in regrasAdicionadas" :key="regra.id" class="regra-chip ativa"
                    :class="{ editavel: regrasEditaveis.includes(regra.nome) }" @click="toggleRegras(regra)" :title="regrasEditaveis.includes(regra.nome)
                      ? 'Clique para remover esta regra'
                      : 'Regra já adicionada — não pode ser removida'
                      ">
                    <i v-if="!regrasEditaveis.includes(regra.nome)" class="ti ti-check"></i>
                    {{ formatarEnum(regra.nome) }}
                    <span v-if="regrasEditaveis.includes(regra.nome)" class="chip-btn-remover">✕</span>
                  </div>
                </div>
              </div>

              <hr class="regras-divider" />

              <div class="regras-section">
                <div class="section-label">
                  <i class="ti ti-circle-plus"></i>
                  Disponíveis para adicionar
                  <span class="badge-count">{{
                    regrasDisponiveis.length
                  }}</span>
                </div>
                <div class="regras-group">
                  <span v-if="regrasDisponiveis.length === 0" class="empty-hint">
                    Todas as regras foram adicionadas.
                  </span>
                  <div v-for="regra in regrasDisponiveis" class="regra-chip disponivel" :class="{
                    'nao-editavel-disp': !regrasEditaveis.includes(
                      regra.nome
                    ),
                  }" @click="toggleRegras(regra)">
                    <i class="ti" :class="regrasEditaveis.includes(regra.nome)
                      ? 'ti-plus'
                      : 'ti-lock'
                      "></i>
                    {{ formatarEnum(regra.nome) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="botoes" style="justify-content: center">
        <button id="enviar" type="submit" class="btn btn-primary center">
          Confirmar alterações
        </button>
      </div>
    </form>
  </div>
  <Aviso v-if="mostrarAviso" :sucesso="sucessoAviso" :texto="mensagemAviso"
    @fechar-modal="handleVoltar('fechar-modal')" />

  <ModalConfirmarSenha :mostrar="modalSenhaVisivel" :carregando="verificandoSenha" :erro="erroSenha"
    @cancelar="fecharModalSenha" @confirmar="onConfirmarSenha" />
</template>
<script setup>
import router from "@/router";
import { onMounted, ref, computed, onBeforeMount, onBeforeUnmount } from "vue";
import { vMaska } from "maska/vue";
import { formatarEnum } from "@/utils/FormatarEntradas";
import regrasService from "@/service/regrasService";
import usuariosService from "@/service/usuariosService";
import Aviso from "@/components/common/aviso.vue";
import ModalConfirmarSenha from "@/components/usuarios/ModalConfirmarSenha.vue";

const mostrarAviso = ref(false);
const sucessoAviso = ref(false);
const mensagemAviso = ref("");

const dadosOriginais = ref();

const regrasSelecionadas = ref([]);
const arquivo = ref();

const regrasAdicionadas = computed(() =>
  regras.value.filter((r) => regrasSelecionadas.value.some((s) => s === r.nome))
);

const regrasDisponiveis = computed(() =>
  regras.value.filter(
    (r) => !regrasSelecionadas.value.some((s) => s === r.nome)
  )
);

function estaSelecionada(regra) {
  return regrasSelecionadas.value.some((r) => r === regra.nome);
}

function houveAlteracao() {
  if (!dadosOriginais.value) return false;
  const nomeAlt =
    (dados.value.nome || "").trim() !==
    (dadosOriginais.value.nome || "").trim();
  const cpfAlt =
    (dados.value.cpf || "").replace(/\D/g, "") !==
    (dadosOriginais.value.cpf || "").replace(/\D/g, "");

  // Normalize dates
  const date1 = dados.value.dataNascimento
    ? new Date(dados.value.dataNascimento).toISOString().split("T")[0]
    : "";
  const date2 = dadosOriginais.value.dataNascimento
    ? new Date(dadosOriginais.value.dataNascimento).toISOString().split("T")[0]
    : "";
  const dataAlt = date1 !== date2;

  return nomeAlt || cpfAlt || dataAlt;
}

const dados = ref({
  nome: "",
  cpf: "",
  dataNascimento: "",
  regras: [],
});

const regras = ref([
  {
    id: "e6e759ae-5790-4938-bfd6-de19141eaf37",
    nome: "ADMINISTRADOR",
  },
  {
    id: "4f8df0cf-a915-408b-8905-f786c170bf96",
    nome: "USUARIO",
  },
  {
    id: "e7efc4ee-2168-46f6-8336-615b8b27cc85",
    nome: "PREX",
  },
  {
    id: "bbe7406a-b7b4-4c37-a27b-20b6c905a7a6",
    nome: "COORDENADOR",
  },
  {
    id: "80d0a265-b218-411c-9944-92ab7a5b5db5",
    nome: "COORDENADORIA",
  },
]);

const props = defineProps({
  dadosUsuario: Object,
});

const emits = defineEmits(["fechar-modal"]);

function handleArquivo(event) {
  const file = event.target.files[0];
  if (!file) return;
  arquivo.value = file;
}

function handleVoltar(paginaPai) {
  switch (paginaPai) {
    case "fechar":
      emits("fechar-modal");
      router.go(-1);
      break;
    case "fechar-modal":
      mostrarAviso.value = false;
      if (sucessoAviso.value) {
        emits("fechar-modal");
        router.replace({ query: {} }).then(() => {
          window.location.reload();
        });
      }
      break;
    default:
      break;
  }
}

const regrasEditaveis = ["COORDENADORIA", "PREX", "ADMINISTRADOR"];

function toggleRegras(regra) {
  if (!regrasEditaveis.includes(regra.nome)) return;

  const index = regrasSelecionadas.value.indexOf(regra.nome);
  if (index > -1) {
    regrasSelecionadas.value.splice(index, 1);
  } else {
    regrasSelecionadas.value.push(regra.nome);
  }
}

const modalSenhaVisivel = ref(false);
const verificandoSenha = ref(false);
const erroSenha = ref("");

function fecharModalSenha() {
  modalSenhaVisivel.value = false;
  erroSenha.value = "";
}

async function onConfirmarSenha(senha) {
  verificandoSenha.value = true;
  erroSenha.value = "";
  try {
    const valida = await usuariosService.verificarSenha(senha);
    if (!valida) {
      erroSenha.value = "Senha do SIGAA incorreta. Tente novamente.";
      return;
    }
    fecharModalSenha();
    await prosseguirComEdicao();
  } catch (error) {
    erroSenha.value = "Erro ao validar senha do SIGAA.";
  } finally {
    verificandoSenha.value = false;
  }
}

function cadastrarEdicao() {
  if (
    dados.value.dataNascimento &&
    dados.value.dataNascimento > dataMaxima.value
  ) {
    sucessoAviso.value = false;
    mensagemAviso.value =
      "A data de nascimento não pode ser uma data futura.";
    mostrarAviso.value = true;
    return;
  }

  const originais = props.dadosUsuario.regras ?? [];

  const regrasParaAdicionar = regrasSelecionadas.value.filter(
    (r) => !originais.includes(r) && regrasEditaveis.includes(r)
  );

  const regrasParaRemover = originais.filter(
    (r) => !regrasSelecionadas.value.includes(r) && regrasEditaveis.includes(r)
  );

  if (regrasParaAdicionar.length > 0 || regrasParaRemover.length > 0) {
    modalSenhaVisivel.value = true;
  } else {
    prosseguirComEdicao();
  }
}

async function prosseguirComEdicao() {
  let alterouRegras = false;
  let errosRegras = [];

  const originais = props.dadosUsuario.regras ?? [];
  const regrasParaAdicionar = regrasSelecionadas.value.filter(
    (r) => !originais.includes(r) && regrasEditaveis.includes(r)
  );
  const regrasParaRemover = originais.filter(
    (r) => !regrasSelecionadas.value.includes(r) && regrasEditaveis.includes(r)
  );

  if (regrasParaAdicionar.length > 0) {
    alterouRegras = true;
    for (const regraNome of regrasParaAdicionar) {
      const regraObj = regras.value.find((r) => r.nome === regraNome);
      const regraId = regraObj ? regraObj.id : null;
      const status = await usuariosService.adicionarRegraGenerica(
        dados.value.id,
        regraId,
        regraNome
      );
      if (status !== 200 && status !== 201) {
        errosRegras.push(`Erro ao adicionar regra ${formatarEnum(regraNome)}`);
      }
    }
  }

  if (regrasParaRemover.length > 0) {
    alterouRegras = true;
    let byUnidade = regrasParaRemover.includes("COORDENADORIA");
    let byPrex = regrasParaRemover.includes("PREX");
    let byAdmin = regrasParaRemover.includes("ADMINISTRADOR");

    if (byAdmin) {
      byUnidade = true;
      byPrex = true;
    }

    const status = await usuariosService.rebaixarCoordenador(
      dados.value.id,
      byUnidade,
      byPrex,
      byAdmin
    );
    if (status !== 200 && status !== 204) {
      errosRegras.push("Erro ao remover regras.");
    }
  }

  let alterouCadastro = houveAlteracao();
  let statusCadastro = 200;
  if (alterouCadastro) {
    if (!arquivo.value) {
      sucessoAviso.value = false;
      mensagemAviso.value =
        "Para alterar dados pessoais (Nome, CPF ou Data de Nascimento), você precisa anexar um documento justificativo em PDF.";
      mostrarAviso.value = true;
      return;
    }
    statusCadastro = await usuariosService.editarPerfilUsuario(
      dados.value,
      arquivo.value,
      dados.value.id
    );
  }

  if (errosRegras.length > 0) {
    sucessoAviso.value = false;
    mensagemAviso.value = errosRegras.join("\n");
  } else if (alterouRegras || alterouCadastro) {
    if (
      statusCadastro === 200 ||
      statusCadastro === 201 ||
      statusCadastro === 204
    ) {
      sucessoAviso.value = true;
      mensagemAviso.value = "Informações editadas com sucesso!";
    } else {
      sucessoAviso.value = false;
      mensagemAviso.value =
        "Ocorreu um erro ao editar as informações. Tente novamente mais tarde.";
    }
  } else {
    sucessoAviso.value = false;
    mensagemAviso.value = "Nenhuma alteração foi realizada.";
  }

  mostrarAviso.value = true;
}
function obterDataLocalHoje() {
  const hoje = new Date();
  const ano = hoje.getFullYear();
  const mes = String(hoje.getMonth() + 1).padStart(2, "0");
  const dia = String(hoje.getDate()).padStart(2, "0");

  return `${ano}-${mes}-${dia}`;
}

const dataMaxima = ref(obterDataLocalHoje());
onMounted(() => {
  dados.value = { ...props.dadosUsuario };
  regrasSelecionadas.value = [...(props.dadosUsuario.regras ?? [])];

  dadosOriginais.value = {
    nome: dados.value.nome,
    cpf: dados.value.cpf,
    dataNascimento: dados.value.dataNascimento,
  };

  document.body.classList.add("modal-aberto");
});

onBeforeUnmount(() => {
  document.body.classList.remove("modal-aberto");
});
</script>
<style scoped>
.form {
  display: flex;
  flex-direction: column;
  width: min(680px, 100%) !important;
  max-width: 100%;
  max-height: min(90vh, 850px);
  padding: 0;
  overflow: hidden;
  color: var(--preto, #24212b);
  background: var(--branco, #fff);
  border-radius: 18px;
  animation: modal-entrada 0.22s ease-out;
}

.modal-header {

  width: 100%;

}





#campos-form-container {
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
}

#campos-form {
  margin: 0;
  padding: 24px 26px;
}

#informacoes {
  width: 100%;
}

#informacoes>.mb-3 {
  margin-bottom: 20px !important;
}

#informacoes>section {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

#informacoes>section>div {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  color: var(--preto, #24212b);
  font-size: 13px;
  font-weight: 600;
}

.form-label.required::before {
  content: "";
}

.form-control {
  width: 100%;
  min-height: 44px;
  padding: 10px 12px;
  color: var(--preto, #24212b);
  font: inherit;
  font-size: 14px;
  background-color: var(--branco, #fff);
  border: 1px solid var(--cinza-claro, #ded9e7);
  border-radius: 9px;
  outline: none;
  box-shadow: 0 1px 2px rgba(25, 15, 40, 0.025);
  transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.form-control:hover {
  border-color: #b9accd;
}

.form-control:focus {
  border-color: var(--roxo-medio, #7650b5);
  box-shadow: 0 0 0 3px rgba(118, 80, 181, 0.14);
}

.form-control::placeholder {
  color: #a29ba9;
}

input[type="file"].form-control {
  min-height: auto;
  padding: 8px;
  background: var(--cinza-fundo, #faf9fc);
  font-size: 13px;
}

input[type="file"]::file-selector-button {
  margin-right: 10px;
  padding: 7px 11px;
  color: var(--roxo-escuro, var(--roxo-medio, #7650b5));
  font-weight: 600;
  background: var(--roxo-superficie, #f3eefb);
  border: 0;
  border-radius: 6px;
  cursor: pointer;
}

/* Feedback do arquivo selecionado */
#arquivo+span {
  overflow-wrap: anywhere;
  line-height: 1.5;
}

#regras-container {
  margin-top: 26px;
  padding: 18px;
  background: var(--cinza-fundo, #faf9fc);
  border: 1px solid var(--cinza-claro, #e8e5ed);
  border-radius: 13px;
}

.regras-section {
  margin-top: 0;
}

.section-label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 13px;
  color: var(--preto, #24212b);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.45px;
  text-transform: uppercase;
}

.section-label>i {
  color: var(--roxo-medio, #7650b5);
  font-size: 17px;
}

.badge-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 23px;
  height: 22px;
  padding: 0 7px;
  color: var(--cinza-medio, #77717f);
  font-size: 11px;
  font-weight: 700;
  background: var(--branco, #fff);
  border: 1px solid var(--cinza-claro, #e8e5ed);
  border-radius: 20px;
  letter-spacing: 0;
}

.regras-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  min-height: 30px;
}

.regra-chip {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  max-width: 100%;
  padding: 8px 11px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.25;
  border: 1px solid;
  border-radius: 8px;
  user-select: none;
  transition: color 0.16s ease, background 0.16s ease, border-color 0.16s ease, transform 0.16s ease;
}

.regra-chip.ativa {
  color: var(--roxo-escuro, var(--roxo-medio, #7650b5));
  background: var(--roxo-claro-10, var(--roxo-superficie, #f3eefb));
  border-color: rgba(118, 80, 181, 0.3);
  cursor: default;
}

.regra-chip.ativa.editavel {
  cursor: pointer;
}

.regra-chip.ativa.editavel:hover {
  color: var(--vermelho-escuro, #a32136);
  background: var(--vermelho-claro, #fff0f1);
  border-color: var(--vermelho, #d94355);
}

.chip-btn-remover {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 17px;
  height: 17px;
  margin-left: 2px;
  color: var(--roxo-escuro, var(--roxo-medio, #7650b5));
  font-size: 10px;
  font-weight: 700;
  background: rgba(118, 80, 181, 0.12);
  border-radius: 50%;
  transition: color 0.16s ease, background 0.16s ease;
}

.regra-chip.ativa.editavel:hover .chip-btn-remover {
  color: #fff;
  background: var(--vermelho, #d94355);
}

.regra-chip.disponivel {
  color: var(--cinza-texto, #514b5a);
  background: var(--branco, #fff);
  border-color: var(--cinza-claro, #ded9e7);
  cursor: pointer;
}

.regra-chip.disponivel:not(.nao-editavel-disp):hover {
  color: var(--roxo-escuro, var(--roxo-medio, #7650b5));
  background: var(--roxo-claro-10, var(--roxo-superficie, #f3eefb));
  border-color: var(--roxo-medio, #7650b5);
  transform: translateY(-1px);
}

.regra-chip.disponivel.nao-editavel-disp {
  opacity: 0.55;
  cursor: not-allowed;
}

.empty-hint {
  padding: 5px 0;
  color: var(--cinza-medio, #77717f);
  font-size: 12px;
  font-style: normal;
  line-height: 1.5;
}

.regras-divider {
  height: 1px;
  margin: 20px 0;
  background: var(--cinza-claro, #e8e5ed);
  border: 0;
}

#botoes {
  display: flex;
  justify-content: flex-end !important;
  gap: 10px;
  padding: 1rem;
  background: var(--branco, #fff);
}

#enviar {
  padding: 8px 25px;
  background-color: var(--roxo-primario);
  color: var(--branco);
  border-radius: 5px;
  border: none;
  font-weight: 500;

}

#enviar:hover {
  background-color: var(--roxo-medio);
}

.btn-fechar-modal:focus-visible,
.regra-chip:focus-visible {
  outline: 3px solid rgba(118, 80, 181, 0.35);
  outline-offset: 2px;
}



@keyframes modal-entrada {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.99);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (max-width: 600px) {
  .overlay {
    align-items: flex-end;
    padding: 10px;
  }

  .form {
    width: 100% !important;
    max-height: 94dvh;
    border-radius: 16px;
  }

  .modal-header {
    padding: 18px 18px 16px;
  }

  .modal-label {
    font-size: 18px;
  }

  #campos-form {
    padding: 19px 18px;
  }

  #informacoes>section {
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
  }

  #regras-container {
    padding: 14px;
  }

  .section-label {
    flex-wrap: wrap;
    font-size: 11px;
  }

  #botoes {
    padding: 14px 18px;
  }

  #enviar {
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {

  .overlay,
  .form {
    animation: none;
  }

  *,
  *::before,
  *::after {
    transition-duration: 0.01ms !important;
  }
}
</style>
